var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dowbox"},[_vm._m(0),_c('sdkdow-btn',{attrs:{"width":"4.4rem","height":"1.4rem","text":"立即下载","isbg":false}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/image/icon/logo.png"),"alt":""}}),_c('p',[_vm._v("超多精彩福利都在这里")])])
}]

export { render, staticRenderFns }